/** Profile photo limits enforced by the API (PNG / JPEG / WebP, 2 MB). */
export const PROFILE_PHOTO_MAX_BYTES = 2 * 1024 * 1024;

/**
 * API path of a profile photo with a cache-busting version, or null when there is none. The
 * server ignores `v`; it only changes the hook's key so a new photo is fetched.
 */
export function photoPath(
  path: string,
  photo: { hasAvatar?: boolean; avatarUpdatedAt?: string | null } | null | undefined,
): string | null {
  return photo?.hasAvatar ? `${path}?v=${encodeURIComponent(photo.avatarUpdatedAt ?? '0')}` : null;
}
